import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { NetworkBannerComponent } from './network-banner.component';

@NgModule({
  imports: [UiModule, CommonModule],
  declarations: [NetworkBannerComponent],
  exports: [NetworkBannerComponent],
})
export class NetworkModule {}
